import React, {useContext} from "react";
import PickListDetail from "../PickListDetail/PickListDetail";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import VendorContext from "../../../contexts/VendorContext";
import {useLocation, useMatch, useNavigate} from "react-router-dom";
import {SocketContext} from "../../../contexts/SocketContext";
import uiContext from "../../../contexts/UiContext";
import UiContext from "../../../contexts/UiContext";

type Props = {};

export const PickListDetailWrapper = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);

    const location = useLocation();
    const navigate = useNavigate();
    const match = useMatch("/pick_lists/:guid");

    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    return <PickListDetail
        match={match}
        socket={socket}
        userModel={userModel}
        supplierModel={supplierModel}
        vendorModel={vendorModel}
        history={navigate}
        setActivityIndicator={uiContext.setActivityIndicator}
        setSidebarComponent={uiContext.setSidebarComponent}
        location={location}
        toggleSidebar={uiContext.toggleSidebar}
        notifyFn={uiContext.notifyFn}
        toggleMenu={uiContext.toggleMenu}
    />;
};
